import Action from "../classes/Action";
import CubemapUtils from "../classes/utilities/CubemapUtils";
import { BuiltInCubeMaps } from "../interfaces/Misc";
import store, { StoreActions } from "../state/store";

export default class SetEnvironmentMapAction extends Action
{
	constructor(envMapAssetId: BuiltInCubeMaps)
	{
		const previousEnvMap = store.getState().preferencesModule.projectSettings.environmentMapId;
		super([envMapAssetId], [previousEnvMap], "Set Environment Map", [envMapAssetId, previousEnvMap]);
	}

	do(envMapAssetId: BuiltInCubeMaps) : void
	{	
		if(!CubemapUtils.getCubemap(envMapAssetId))
		{
			CubemapUtils.loadCubemap(envMapAssetId).then(() =>
			{
				store.dispatch(StoreActions.preferences.setProjectSettings({ environmentMapId: envMapAssetId }));
			});
		}
		else
		{
			store.dispatch(StoreActions.preferences.setProjectSettings({ environmentMapId: envMapAssetId }));
		}
	}

	verify(newEnvMapId: BuiltInCubeMaps, prevEnvMapId: BuiltInCubeMaps): boolean
	{
		return newEnvMapId !== prevEnvMapId;
	}
}
